import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { LogIn, Truck } from "lucide-react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function LoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    
    if (!email || !password) {
      toast.error("Veuillez remplir tous les champs");
      return;
    }

    setLoading(true);
    
    try {
      const response = await axios.post(`${API}/auth/login`, {
        email,
        password
      });

      if (response.data.success) {
        // Store token and employee info
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("employee", JSON.stringify(response.data.employee));
        
        toast.success(`Bienvenue ${response.data.employee.firstname}!`);
        navigate("/search");
      } else {
        toast.error(response.data.message || "Échec de connexion");
      }
    } catch (error) {
      console.error("Login error:", error);
      toast.error(error.response?.data?.detail || "Erreur de connexion");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-6 bg-white">
      <div className="w-full max-w-md animate-slide-up">
        {/* Logo / Header */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-[#e5007c] border-2 border-black shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] mb-4">
            <Truck className="w-10 h-10 text-white" />
          </div>
          <h1 
            className="text-4xl font-black tracking-tight uppercase text-black"
            style={{ fontFamily: 'Chivo, sans-serif' }}
          >
            FRUITSELECT
          </h1>
          <p className="text-lg font-medium text-gray-600 mt-2 uppercase tracking-wider">
            Espace Livreur
          </p>
        </div>

        {/* Login Form */}
        <div className="card-brutalist">
          <form onSubmit={handleLogin} className="space-y-6">
            <div className="space-y-2">
              <Label 
                htmlFor="email" 
                className="text-sm font-bold uppercase tracking-wider text-gray-700"
              >
                Email Employé
              </Label>
              <Input
                id="email"
                type="email"
                placeholder="votre.email@fruitselect.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="input-brutalist"
                data-testid="login-email"
                autoComplete="email"
              />
            </div>

            <div className="space-y-2">
              <Label 
                htmlFor="password" 
                className="text-sm font-bold uppercase tracking-wider text-gray-700"
              >
                Mot de passe
              </Label>
              <Input
                id="password"
                type="password"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="input-brutalist"
                data-testid="login-password"
                autoComplete="current-password"
              />
            </div>

            <Button
              type="submit"
              className="btn-primary w-full"
              disabled={loading}
              data-testid="login-submit"
            >
              {loading ? (
                <span className="flex items-center gap-2">
                  <span className="animate-spin">⏳</span>
                  CONNEXION...
                </span>
              ) : (
                <span className="flex items-center gap-2">
                  <LogIn className="w-5 h-5" />
                  CONNEXION
                </span>
              )}
            </Button>
          </form>
        </div>

        {/* Footer */}
        <p className="text-center text-sm text-gray-500 mt-6">
          Accès réservé aux livreurs FruitSelect
        </p>
      </div>
    </div>
  );
}
